import { render, staticRenderFns } from "./ModalFormRedirect.vue?vue&type=template&id=241ad18d&scoped=true&"
import script from "./ModalFormRedirect.vue?vue&type=script&lang=ts&"
export * from "./ModalFormRedirect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241ad18d",
  null
  
)

export default component.exports